import RealTimeGradientCalculator from './real-time-gradient-calculator';
import ConventionalPcrGradientCalculator from './conventional-pcr-gradient-calculator';

// eslint-disable-next-line import/prefer-default-export
export { RealTimeGradientCalculator, ConventionalPcrGradientCalculator };
